import axios from 'axios'
import moment from 'moment'

const state = () => ({
  cardReport: null,
  selectedFollowUp: null,

  // Filter Report Progress
  selectedClients: [],
  listStores: [],
  tempDateScrollTo: {
    startDate: null,
    endDate: null
  },
  saveDateFilterProgress: null,
  dataNavbarReportProgress: [
    {
      title: 'Survey Diminta',
      afterTitle: 'survey-diminta',
      tooltipDesc: 'Daftar permintaan survey yang dibuat oleh client',
      idx_column_report: 0
    },
    {
      title: 'Survey Terjadwal',
      afterTitle: 'survey-terjadwal',
      tooltipDesc: 'Daftar survey yang harus dilakukan',
      idx_column_report: 1
    },
    {
      title: 'Survey Dilakukan',
      afterTitle: 'survey-dilakukan',
      tooltipDesc: 'Daftar Survey tampil apabila konsultan melakukan absen',
      idx_column_report: 2
    },
    {
      title: 'Proses SM',
      afterTitle: 'proses-sm',
      idx_column_report: 3
    },
    {
      title: 'Proses Purchasing',
      afterTitle: 'proses-purchasing',
      idx_column_report: 4
    },
    {
      title: 'Proses BS',
      afterTitle: 'proses-bs',
      idx_column_report: 5
    },
    {
      title: 'Penawaran Terkirim',
      afterTitle: 'penawaran-terkirim',
      idx_column_report: 6
    },
    {
      title: 'Penawaran Disetujui',
      afterTitle: 'penawaran-disetujui',
      idx_column_report: 7
    },
    {
      title: 'Penawaran Ditolak',
      afterTitle: 'penawaran-ditolak',
      idx_column_report: 8
    },
    {
      title: 'SPK SIK Diterima',
      afterTitle: 'spk-sik-diterima',
      idx_column_report: 9
    },
    {
      title: 'Persiapan Material Purchasing',
      afterTitle: 'persiapan-material-purchasing',
      tooltipDesc: 'Daftar proyek yang sedang menunggu preparasi material',
      idx_column_report: 10
    },
    {
      title: 'Proyek Dibuat',
      afterTitle: 'proyek-dibuat',
      idx_column_report: 11
    },
    {
      title: 'Assign Tukang',
      afterTitle: 'assign-tukang',
      idx_column_report: 12
    },
    {
      title: 'Proyek Berlangsung',
      afterTitle: 'proyek-berlangsung',
      tooltipDesc: 'Daftar proyek yang sedang dalam proses pengerjaan tukang',
      additionalDesc: 'Perubahan status absen secara manual akan mempengaruhi riwayat progress untuk proyek ini pada halaman Report Progress',
      idx_column_report: 13
    },
    {
      title: 'Pekerjaan Selesai',
      afterTitle: 'pekerjaan-selesai',
      tooltipDesc: 'Daftar proyek menunggu konfirmasi tukang jagoan',
      idx_column_report: 14
    },
    {
      title: 'Konfirmasi Pekerjaan Selesai',
      afterTitle: 'konfirmasi-pekerjaan-selesai',
      tooltipDesc: 'Proyek sedang menunggu Konfirmasi client atau menunggu invoice diterbitkan',
      idx_column_report: 15
    },
    {
      // title: 'Pengiriman Invoice',
      title: 'Invoice Terkirim',
      afterTitle: 'invoice-terkirim',
      tooltipDesc: 'Rekap invoice yang sudah dan belum dikirim oleh Business Support',
      idx_column_report: 16
    },
    {
      title: 'Pembayaran',
      afterTitle: 'terbayar',
      idx_column_report: 17
    }
  ],

  // FILTER REPORT PROGRESS
  filterReportProgress: {
    payloadSurveyId: '',
    payloadClients: '',
    payloadStores: '',
    payloadDates: null,
    payloadDueDates: null,
    payloadStatus: null
  },
  tooltipCardProgress: {
    visible: false,
    hover_tooltip: false,
    data: null,
    loading: null,
    tooltip_target: null,
    zoom: 0,
    x: 0,
    y: 0
  }
})

const getters = {
  cardReport: (state, getters, rootState) => {
    return state.cardReport
  },
  getSelectedFollowUp: (state, getters, rootState) => {
    return state.selectedFollowUp
  },
  getSelectedClients: (state, getters, rootState) => {
    return state.selectedClients
  },
  getListStores: (state, getters, rootState) => {
    return state.listStores
  },
  getTempDateScrollTo: (state, getters, rootState) => {
    return state.tempDateScrollTo
  },
  getDataNavbarReportProgress: (state) => {
    return state.dataNavbarReportProgress
  },
  getSaveDateFilterProgress: (state) => {
    return state.saveDateFilterProgress
  },
  getFilterReportProgress: (state) => {
    return state.filterReportProgress
  },
  getTooltipCardProgress: (state) => {
    return state.tooltipCardProgress
  }
}

const actions = {
  getCardReport ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`${payload.url}${process.env.VUE_APP_CARD_REPORT}`)
        .then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getListReport ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`${payload.url}${process.env.VUE_APP_LIST_REPORT}`)
        .then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getListReportFollowUp ({ commit, state }, payload) {
    let concatUrl = ''
    const { page, limit, search, vendor, status, startDate, endDate, orderBy, order } = payload

    if (page) {
      concatUrl += `page=${page}&`
    }
    if (limit) {
      concatUrl += `limit=${limit}&`
    }
    if (search) {
      concatUrl += `search=${search}&`
    }
    if (vendor) {
      concatUrl += `vendor=${vendor}&`
    }
    if (status) {
      concatUrl += `status=${status}&`
    }
    if (startDate) {
      concatUrl += `start_date=${startDate}&`
    }
    if (endDate) {
      concatUrl += `end_date=${endDate}&`
    }
    if (orderBy) {
      concatUrl += `order_by=${orderBy}&`
    }
    if (order) {
      concatUrl += `order=${order}&`
    }

    return new Promise((resolve, reject) => {
      axios.get(`${payload.url}${process.env.VUE_APP_REPORT_FOLLOW_UP}${payload.isExport ? `/export${payload.excel ? '/excel' : ''}` : ''}?${concatUrl}`)
        .then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  putReportFollowUp ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      const body = {
        date: payload.date
      }

      axios.put(`${payload.url}${process.env.VUE_APP_REPORT_FOLLOW_UP}/${payload.surveyId}/${payload.type}`, body)
        .then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getSimpleListVendor ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`${payload.url}${process.env.VUE_APP_REPORT_PROGRESS}/store`)
        .then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getListReportProgress ({ commit, state }, payload) {
    const { surveyId, clients, stores, startDate, endDate, startDueDate, endDueDate, status, summary, path = 'table' } = payload

    const params = {}
    if (surveyId) {
      params.survey_id = surveyId
    }
    if (clients) {
      params.vendor_ids = clients
    }
    if (stores) {
      params.store_ids = stores
    }
    if (startDate) {
      params.start_date = moment(startDate).format('YYYY-MM-DD')
    }
    if (endDate) {
      params.end_date = moment(endDate).format('YYYY-MM-DD')
    }
    if (startDueDate) {
      params.invoice_start_date = moment(startDueDate).format('YYYY-MM-DD')
    }
    if (endDueDate) {
      params.invoice_end_date = moment(endDueDate).format('YYYY-MM-DD')
    }
    if (status) {
      params.status = status
    }
    if (summary) {
      params.start_date = summary.end_date
      params.end_date = summary.start_date
    }

    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_REPORT_PROGRESS_V2}/${path}`, { params })
        .then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getTooltipInformation ({ commit, state }, payload) {
    const { surveyId, status, startDate, endDate } = payload
    const concatUrl = `?survey_id=${surveyId}&status=${status}&start_date=${startDate}&end_date=${endDate}`

    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_REPORT_PROGRESS_V2}/info${concatUrl}`)
        .then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  postRejectConfirm ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`${payload.url}${process.env.VUE_APP_REPORT_PROGRESS}/reject-confirm/${payload.surveyId}`)
        .then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  exportExcelMaterial ({ commit, state }, payload) {
    const { offeringId } = payload

    return new Promise((resolve, reject) => {
      axios.post(`${payload.url}${process.env.VUE_APP_DATA_PENAWARAN}/${offeringId}/materials-to-xls`)
        .then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getListClients ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`${payload.url}${process.env.VUE_APP_REPORT_PROGRESS_V2}/vendors`)
        .then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
    })
  }
}

const mutations = {
  setCardReport (state, cardReport) {
    state.cardReport = cardReport
  },
  setSelectedFollowUp (state, value) {
    state.selectedFollowUp = value
  },
  setSelectedClients (state, value) {
    if (value === 'reset') {
      state.selectedClients = []
      state.listStores = []
    }
    const index = state.selectedClients.findIndex(client => client.vendor_id === value.vendor_id)

    if (value.selected) {
      if (index === -1) state.selectedClients.push(value)
    } else {
      if (index !== -1) state.selectedClients.splice(index, 1)
    }
    state.listStores = state.selectedClients.flatMap(client => client.list_stores)
  },
  setTempDateScrollTo (state, value) {
    state.tempDateScrollTo = value
  },
  setSaveDateFilterProgress (state, value) {
    state.saveDateFilterProgress = value
  },
  setTooltipCardProgress (state, value) {
    if ('x' in value) state.tooltipCardProgress.x = value.x
    if ('y' in value) state.tooltipCardProgress.y = value.y
    if ('visible' in value) state.tooltipCardProgress.visible = value.visible
    if ('hover_tooltip' in value) state.tooltipCardProgress.hover_tooltip = value.hover_tooltip
    if ('data' in value) state.tooltipCardProgress.data = value.data
    if ('loading' in value) state.tooltipCardProgress.loading = value.loading
    if ('zoom' in value) state.tooltipCardProgress.zoom = value.zoom
    if ('tooltip_target' in value) state.tooltipCardProgress.tooltip_target = value.tooltip_target
  },
  setFilterReportProgress (state, value) {
    const { data, type } = value
    switch (type) {
      case 'survey_id':
        state.filterReportProgress.payloadSurveyId = data
        break

      case 'client':
        state.filterReportProgress.payloadClients = data
        break

      case 'store':
        state.filterReportProgress.payloadStores = data
        break

      case 'dates':
        state.filterReportProgress.payloadDates = data
        break

      case 'due_dates':
        state.filterReportProgress.payloadDueDates = data
        break

      case 'status':
        state.filterReportProgress.payloadStatus = data
        break

      default:
        break
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
